import { STORE_GROUPS } from "./content";

export function Lojas(): JSX.Element {
  return (
    <section id="lojas" aria-labelledby="lojas-heading" className="scroll-mt-20 border-t border-border bg-surface/40">
      <div className="mx-auto max-w-[77.5rem] px-4 py-24 sm:px-6 lg:px-8">
        <h2
          id="lojas-heading"
          className="text-[clamp(2rem,1.4rem+2.2vw,3.25rem)] font-bold leading-[1.05] tracking-[-0.035em]"
        >
          Sete lojas. Duas regras.
        </h2>

        <div className="mt-14 grid gap-14 md:grid-cols-2 md:gap-10">
          {STORE_GROUPS.map((group) => (
            <div key={group.title}>
              <h3 className="text-lg font-semibold tracking-[-0.02em]">{group.title}</h3>
              <p className="mt-2 max-w-[40ch] text-[0.9375rem] leading-relaxed text-muted-foreground">{group.text}</p>
              <ul className="mt-8 border-t border-border-strong">
                {group.stores.map((store) => (
                  <li
                    key={store}
                    className="group flex items-center justify-between border-b border-border py-4 text-[clamp(1.75rem,1.2rem+1.8vw,2.75rem)] font-semibold leading-none tracking-[-0.035em]"
                  >
                    <span className="lp-marker group-hover:[background-size:100%_100%] group-hover:text-signal-foreground">
                      {store}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
